var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cancel"},[_c('div',{staticClass:"cancel-text"},[_vm._v(" "+_vm._s(_vm.$t('matches.server_cancel_description'))+" ")]),_c('pvp-btn',{attrs:{"is-loading":_vm.loadingState.cancel,"variant":"secondary"},on:{"click":_vm.cancelServer}},[_vm._v(" "+_vm._s(_vm.$t('matches.server_cancel_button'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }